import React from "react";
import { Link } from "react-router-dom";
import timg1 from '../../images/timg1.png'
import timg2 from '../../images/timg2.png'
import timg3 from '../../images/timg3.png'
import timg4 from '../../images/timg4.png'
import timg5 from '../../images/timg5.png' 
import timg6 from '../../images/timg6.png'


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const PatentSection = (props) => {
    const { circlebottom = true } = props
    const Teams = [
        {
            id: '1',
            title: 'ISO 9001인증(품질)',
            subtitle: 'ISO 9001인증(품질)',
            slug: 'ISO-9001-1',
            timg: timg1,
        },
        {
            id: '2',
            title: 'ISO 9001인증(품질)',
            subtitle: 'ISO 9001인증(품질)',
            slug: 'ISO-9001-2',
            timg: timg2,
        },
        {
            id: '3',
            title: 'ISO 14001인증(환경)',
            subtitle: 'ISO 14001인증(환경)',
            slug: 'ISO-14001-1',
            timg: timg3,
        },
        {
            id: '4',
            title: 'ISO 14001인증(환경)',
            subtitle: 'ISO 14001인증(환경)',
            slug: 'ISO-14001-2',
            timg: timg4,
        },
        {
            id: '5',
            title: 'ISO 45001인증(안전)',
            subtitle: 'ISO 45001인증(안전)',
            slug: 'ISO-45001-1',
            timg: timg5,
        }
        ,
        {
            id: '6',
            title: 'ISO 45001인증(안전)',
            subtitle: 'ISO 45001인증(안전)',
            slug: 'ISO-45001-2',
            timg: timg6,
        }
    ]

    return (
        <section className="team-section-s2 section-padding">
            <div className="container">
                <div className="title">
                    <h2 className="scroll-text-animation patent-title" data-animation="fade_from_bottom">인증 및 인허가 현황 {window.innerWidth < 780 && <br/>} (Certifications & License).</h2>
                    <div className="title-bottom">
                        <h3 className="scroll-text-animation patent-subtitle" data-animation="fade_from_bottom">독보적인 인허가 현황을 소개합니다.</h3>
                    </div>
                </div>
                <div className="row">
                    {Teams.map((team, titem) => (
                        <div className="col-lg-3 col-md-6 col-12 fade_bottom" key={titem}>
                            <div className="team-card">
                                <div className="image">
                                    <img src={team.timg} alt="" />
                                    <img src={team.timg} alt="" />
                                </div>
                                <div className="text">
                                    {/* <h2><a>
                                        {team.title}
                                    </a>
                                    </h2> */}
                                    <span style={{backgroundColor:"#61666E20", color:"#000", padding:"5px 10px", borderRadius:"10px"}} >{team.subtitle}</span>
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </section>


    )
}
export default PatentSection;
